import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { getEventsUserList, getEvaluatorsList, setUserEvaluator, setEventEvaluator, deleteEvaluator } from "../../../store/actions/createEvents.actions";
import Message from "../../Common/Message";

const mapStateToProps = (state) => ({
    newEventID: state.createEvent.newEventID,
    evaluatorsList: state.createEvent.evaluatorsList,
    selectedEvaluator: state.createEvent.selectedEvaluator,
    usersList: state.createEvent.eventUsers,
});

const mapDispatchToProps = (dispatch: any) => ({
    getEventsUserList: (data) => (dispatch(getEventsUserList(data))),
    getEvaluatorsList: (data) => (dispatch(getEvaluatorsList(data))),
    setUserEvaluator: (data) => (dispatch(setUserEvaluator(data))),
    setEventEvaluator: (data) => (dispatch(setEventEvaluator(data))),
    deleteEvaluator: (data) => (dispatch(deleteEvaluator(data)))
});

class AddEvaluator extends Component<Props, State> {
    constructor(props) {
        super(props);

        this.state = {
            searchTerm: "",
            showDropdown: false,
            addEvaluatorError: false
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount = () => {
        const { getEventsUserList, getEvaluatorsList, newEventID } = this.props;
        const data = {
            eventId: newEventID,
            isOrganizer: false
        };
        getEventsUserList(data);
        getEvaluatorsList(newEventID);
    };

    handleChange(event) {
        const value = event.target.value;
        this.setState({
            [event.target.name]: value,
            showDropdown: true
        });
    };

    handleSelect = (user) => {
        const { setUserEvaluator } = this.props;
        setUserEvaluator(user.id);
        this.setState({
            searchTerm: user.email,
            showDropdown: false
        });
    };

    handleAddEvaluator = () => {
        const { setEventEvaluator, selectedEvaluator, newEventID, setUserEvaluator } = this.props;
        if (selectedEvaluator === null) {
            this.setState({
                addEvaluatorError: true
            });
        }
        else {
            const data = {
                eventId: newEventID,
                userId: selectedEvaluator
            };
            setEventEvaluator(data);
            this.setState({
                searchTerm: ""
            });
            setUserEvaluator(null);
        }
    };

    handleDeleteEvaluator = (id) => {
        const { newEventID, deleteEvaluator } = this.props;
        const data = {
            eventId: newEventID,
            userId: id
        };
        deleteEvaluator(data);
    };

    render() {
        const { usersList, evaluatorsList } = this.props;
        const { searchTerm, showDropdown, addEvaluatorError } = this.state;

        return (
            <>
                {addEvaluatorError && (
                    <Message type="danger"
                        defaultMessage={"Please Select a User to add"}
                        baseClassName="alert"
                    ></Message>
                )}
                <div className="form-row">
                    <span className="mt-2">Search: &nbsp; </span>{/* <em className="fa fa-search"></em> */}
                    <input className="mr-5"
                        style={{ borderColor: "lightgray", borderWidth: "1px", width: "300px" }}
                        placeholder="&nbsp;&nbsp;Search User..."
                        value={searchTerm}
                        name="searchTerm"
                        autoComplete="off"
                        onChange={this.handleChange} />
                    <button className="btn btn-secondary" style={{ backgroundColor: "#00456c", color: "white" }} onClick={() => this.handleAddEvaluator()}>Add</button>
                </div><br />
                <div className="form-row">
                    {showDropdown && searchTerm && (
                        <ul
                            style={{
                                listStyle: "none",
                                margin: 0,
                                padding: "0.5rem",
                                border: "1px solid #ccc",
                                position: "relative",
                                width: "100%",
                                backgroundColor: "#fff",
                                zIndex: 1
                            }}
                        >
                            {usersList.length > 0 ? (
                                usersList &&
                                usersList
                                    .filter(user => user.email.toLowerCase().includes(searchTerm.toLowerCase())
                                    ).map(user => (
                                        <li
                                            key={user.id}
                                            onClick={() => this.handleSelect(user)}
                                            style={{
                                                padding: "0.3rem 0",
                                                cursor: "pointer"
                                            }}
                                        >
                                            <strong>{user.name}</strong> - {user.email}
                                        </li>
                                    ))
                            ) : (
                                <li style={{ color: "#999" }}>No match found</li>
                            )}
                        </ul>
                    )}
                </div>
                <div className="form-row">
                    {evaluatorsList && evaluatorsList.length > 0 ? (
                        <table className="table table-striped table-hover w-100 vw-table">
                            <thead>
                                <tr>
                                    <th className="text-center">
                                        <strong>Name</strong>
                                    </th>
                                    <th className="text-center">
                                        <strong>Email</strong>
                                    </th>
                                </tr></thead>
                            <tbody>
                                {evaluatorsList
                                    .map((data) => (
                                        <tr key={data.id}>
                                            <td align="center">{data.name}</td>
                                            <td align="center">{data.email}</td>
                                            <td><button className="btn btn-sm btn-secondary ml-2" style={{ width: "35px" }} onClick={() => this.handleDeleteEvaluator(data.id)}>
                                                <em className="fa fa-trash mr-4"></em>
                                            </button></td></tr>))}
                            </tbody></table>) : <Fragment>
                        <div style={{ padding: "5px" }}>
                            <span>No records</span>
                        </div>
                    </Fragment>}</div></>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddEvaluator);